<script setup>
import JetNavLink from '@/Jetstream/NavLink.vue';
import JetResponsiveNavLink from '@/Jetstream/ResponsiveNavLink.vue';
import { ref } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import { Head, Link } from '@inertiajs/inertia-vue3';
import JetApplicationMark from '@/Jetstream/ApplicationMark.vue';
import JetDropdown from '@/Jetstream/Dropdown.vue';
import JetDropdownLink from '@/Jetstream/DropdownLink.vue';
import JetButton from '@/Jetstream/Button.vue';
import { useForm } from '@inertiajs/inertia-vue3'

defineProps({
    title: String,
});

const showingNavigationDropdown = ref(false);

const switchToTeam = (team) => {
    Inertia.put(route('current-team.update'), {
        team_id: team.id,
    }, {
        preserveState: false,
    });
};

const logout = () => {
    Inertia.post(route('logout'));
};

const form = useForm({
    search: '',
    searchTarget: 'buy'
});

const submit = function() {
    if(form.searchTarget){
        switch (form.searchTarget) {
            case 'buy':
                Inertia.visit(route('buy', {search: form.search}));
                break;
            case 'rent':
                Inertia.visit(route('rent', {search: form.search}));
                break;
            case 'international-properties':
                Inertia.visit(route('international-properties', {search: form.search}));
                break;

            default:
                break;
        }
    }
}
</script>

<script>
export default {
    mounted(){
        document.querySelector('.navbar-toggler')?.addEventListener('click', () => {
            document.querySelector('.side-nav').classList.add('opened-sidenav')
        })

        document.querySelector('.hide-nav')?.addEventListener('click', () => {
            document.querySelector('.side-nav').classList.remove('opened-sidenav')
        })

        let navElements = document.getElementsByClassName('nav-bar-dropdown-toggle')
        if(navElements.length > 0){
            Array.from(navElements).forEach(element => {
                element?.addEventListener('mouseover', (e) => {

                    Array.from(document.getElementsByClassName('nav-bar-dropdown-toggle')).forEach(element => {
                        element.nextElementSibling.style.display = "none";
                    });

                    let x = e.target.nextSibling;
                    if (x.style.display === "none") {
                        x.style.display = "block";
                    } else {
                        setTimeout(() => {
                            x.style.display = "none";
                        }, 1200);
                    }
                });

                element?.addEventListener('mouseout', (e) => {
                    setTimeout(() => {
                        element.nextElementSibling.style.display = "none";
                    }, 4000);
                });
            });
        }

        document.getElementById('dropdown-menu-search')?.addEventListener('click', function (e) {
            var el = this.nextElementSibling
            el.style.display = el.style.display==='block'?'none':'block'
        })

        document.getElementById('dropdown-menu-search-mobile')?.addEventListener('click', function (e) {
            var el = this.nextElementSibling
            if(el.classList.contains('show')){
                el.classList.remove('show');
            }else{
                el.classList.add('show');
            }
        })

        document.addEventListener('click', e => {
            if(!e.target.classList.contains('nav-bar-dropdown-toggle')){
                Array.from(document.getElementsByClassName('nav-bar-dropdown-toggle')).forEach(element => {
                    element.nextElementSibling.style.display = "none";
                });
            }
        });
    }
}
</script>

<template>
    <header class="header">
        <nav class="navbar navbar-expand-lg navbar-dark">
            <div class="container-fluid">
                <a class="navbar-brand" href="/">
                    <figure class="mb-0">
                        <img :src="asset('/images/logo-pgn-inspire-properties.png')" alt="'Inspire Properties'">
                    </figure>
                </a>

                <div class="d-flex d-lg-none">
                    <button type="button" class="btn bg-transparent" id="dropdown-menu-search-mobile">
                        <svg xmlns="http://www.w3.org/2000/svg" style="width: 20px; color: white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                    </button>
                    <div class="dropdown-menu w-100 mt-0 animate__animated animate__slideInDown animate__faster" id="mobile-search-dropdown" data-bs-popper="none">
                        <div class="d-flex w-100 justify-content-center">
                            <div class="col-10 col-sm-8">
                                <div class=""><h4>Search</h4></div>
                                <div class="p-3">
                                    <form action="" method="post" @submit.prevent="submit">
                                        <div class="mb-3">
                                            <div class="d-flex justify-content-start">
                                                <div class="me-4">
                                                    <input class="searchTarget" id="searchBuy" type="radio" required value="buy" v-model="form.searchTarget" checked><label for="searchBuy">Buy</label>
                                                </div>
                                                <div class="me-4">
                                                    <input class="searchTarget" id="searchSell" type="radio" required value="rent" v-model="form.searchTarget"><label for="searchSell">Rent</label>
                                                </div>
                                                <div class="me-4">
                                                    <input class="searchTarget" id="searchInt" type="radio" required value="international-properties" v-model="form.searchTarget"><label for="searchInt">International</label>
                                                </div>
                                            </div>
                                            <div class="input-group mt-3">
                                                <div class="input-group-text rounded-0 bg-transparent border-end-0">
                                                    <button type="button" class="btn bg-transparent p-0 m-0 border-0 disabled text-white">
                                                        <svg xmlns="http://www.w3.org/2000/svg" style="width: 16px; margin-top: -5px" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                                            <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                                        </svg>
                                                    </button>
                                                </div>
                                                <input required minlength="2" maxlength="255" type="text" v-model="form.search" class="bg-transparent rounded-0 form-control text-white shadow-none border-white border-start-0 border-end-0" placeholder="Search Properties" aria-describedby="helpId">
                                                <div class="input-group-text rounded-0 bg-transparent border-start-0">
                                                    <button type="submit" class="btn bg-transparent p-0 m-0 border-0 text-white">
                                                        <svg class="infinite-search" xmlns="http://www.w3.org/2000/svg" style="width: 16px; margin-top: -5px" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                                            <path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button class="navbar-toggler" type="button">
                        <svg stroke="currentColor" fill="none" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M22 18.0048C22 18.5544 21.5544 19 21.0048 19H12.9952C12.4456 19 12 18.5544 12 18.0048C12 17.4552 12.4456 17.0096 12.9952 17.0096H21.0048C21.5544 17.0096 22 17.4552 22 18.0048Z" fill="currentColor"></path><path d="M22 12.0002C22 12.5499 21.5544 12.9954 21.0048 12.9954H2.99519C2.44556 12.9954 2 12.5499 2 12.0002C2 11.4506 2.44556 11.0051 2.99519 11.0051H21.0048C21.5544 11.0051 22 11.4506 22 12.0002Z" fill="currentColor"></path><path d="M21.0048 6.99039C21.5544 6.99039 22 6.54482 22 5.99519C22 5.44556 21.5544 5 21.0048 5H8.99519C8.44556 5 8 5.44556 8 5.99519C8 6.54482 8.44556 6.99039 8.99519 6.99039H21.0048Z" fill="currentColor"></path></svg>
                    </button>
                </div>

                <div class="collapse navbar-collapse">
                    <ul class="navbar-nav ms-auto mb-2 mb-lg-0 align-items-center">
                        <!-- <li class="nav-item">
                            <a class="nav-link nav-bar-dropdown-toggle dropdown-toggle text-center"
                                :class="(route().current() == 'development-consultancy') ? 'active' : ''" :href="route('development-consultancy')">Development <br> Consultancy</a>
                            <ul class="dropdown-menu" style="display: none;">
                                <div class=""><h4>Development Consultancy</h4></div>
                                <JetNavLink class="nav-link" :href="route('development-consultancy') + '#end'">End To End Service</JetNavLink>
                                <JetNavLink class="nav-link" :href="route('development-consultancy') + '#value-addition'">Value Addition</JetNavLink>
                                <JetNavLink class="nav-link" :href="route('development-consultancy') + '#associate'">Our Associates</JetNavLink>
                            </ul>
                        </li> -->
                        <li class="nav-item">
                            <JetNavLink class="nav-link text-center adjust-margin" :class="route().current() == 'development-consultancy' ? 'active' : ''" :href="route('development-consultancy')">Development <br> Consultancy</JetNavLink>
                        </li>
                        <li class="nav-item">
                            <JetNavLink class="nav-link text-center py-0 py-lg-3 adjust-margin" :class="route().current() == 'bulk-investments' ? 'active' : ''" :href="route('bulk-investments')">Bulk Investments</JetNavLink>
                        </li>
                        <li class="nav-item">
                            <JetNavLink class="nav-link py-3 adjust-margin" :class="route().current() == 'buy' ? 'active' : ''" :href="route('buy')">Buy </JetNavLink>
                        </li>
                        <li class="nav-item">
                            <JetNavLink class="nav-link py-3 adjust-margin" :class="route().current() == 'sell' ? 'active' : ''" :href="route('sell')">Sell </JetNavLink>
                        </li>
                        <li class="nav-item">
                            <JetNavLink class="nav-link py-3 adjust-margin" :class="route().current() == 'rent' ? 'active' : ''" :href="route('rent')">Rent </JetNavLink>
                        </li>
                        <!-- <li class="nav-item">
                            <a class="nav-link nav-bar-dropdown-toggle dropdown-toggle text-center"
                                :class="(route().current() == 'buy' || route().current() == 'rent' || route().current() == 'sell' || route().current() == 'international-properties') ? 'active' : ''" href="javascript:void(0);">Individual Units </a>
                            <ul class="dropdown-menu" style="display: none;">
                                <div class=""><h4>Individual Units</h4></div>
                                <JetNavLink class="nav-link" :class="(route().current() == 'buy') ? 'activeSub' : ''" :href="route('buy')">Buy</JetNavLink>
                                <JetNavLink class="nav-link" :class="(route().current() == 'rent') ? 'activeSub' : ''" :href="route('rent')">Rent</JetNavLink>
                                <JetNavLink class="nav-link" :class="(route().current() == 'sell') ? 'activeSub' : ''" :href="route('sell')">Sell</JetNavLink>
                                <JetNavLink class="nav-link" :class="(route().current() == 'international-properties') ? 'activeSub' : ''" :href="route('international-properties')">International Properties</JetNavLink>
                            </ul>
                        </li> -->
                        <li class="nav-item">
                            <JetNavLink class="nav-link py-3 adjust-margin" :class="route().current() == 'about' ? 'active' : ''" :href="route('about')">About</JetNavLink>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link nav-bar-dropdown-toggle dropdown-toggle py-3"
                                :class="(route().current() == 'buyers-handbook' || route().current() == 'sellers-handbook' || route().current() == 'tenants-handbook' || route().current() == 'landlords-handbook') ? 'active' : ''" href="javascript:void(0);">Insights </a>
                            <ul class="dropdown-menu" style="display: none;">
                                <div class=""><h4>Insights</h4></div>
                                <JetNavLink class="nav-link" :class="(route().current() == 'buyers-handbook') ? 'activeSub' : ''" :href="route('buyers-handbook')">Buyer's Handbook</JetNavLink>
                                <JetNavLink class="nav-link" :class="(route().current() == 'sellers-handbook') ? 'activeSub' : ''" :href="route('sellers-handbook')">Seller's Handbook</JetNavLink>
                                <JetNavLink class="nav-link" :class="(route().current() == 'tenants-handbook') ? 'activeSub' : ''" :href="route('tenants-handbook')">Tenant's Handbook</JetNavLink>
                                <JetNavLink class="nav-link" :class="(route().current() == 'landlords-handbook') ? 'activeSub' : ''" :href="route('landlords-handbook')">Landlord's Handbook</JetNavLink>
                                <JetNavLink class="nav-link" :class="(route().current() == 'neighbourhood-diaries' || route().current() == 'neighbourhood-diary.show') ? 'activeSub' : ''" :href="route('neighbourhood-diaries')">Neighbourhood Diaries</JetNavLink>
                            </ul>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link nav-bar-dropdown-toggle dropdown-toggle text-center py-3"
                                :class="(route().current() == 'contact' || route().current() == 'careers' || route().current() == 'partners') ? 'active' : ''" href="javascript:void(0);">Contact </a>
                            <ul class="dropdown-menu" style="display: none;">
                                <div class=""><h4>Contact</h4></div>
                                <JetNavLink class="nav-link" :class="(route().current() == 'contact') ? 'activeSub' : ''" :href="route('contact')">Contact Us</JetNavLink>
                                <JetNavLink class="nav-link" :class="(route().current() == 'careers') ? 'activeSub' : ''" :href="route('careers')">Careers</JetNavLink>
                                <!-- <JetNavLink class="nav-link" :class="(route().current() == 'partners') ? 'activeSub' : ''" :href="route('partners')">Partners</JetNavLink> -->
                            </ul>
                        </li>
                    </ul>
                    <div class="form-right-search">
                        <div class="position-relative">
                            <button type="button" class="search-btn" id="dropdown-menu-search">
                                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                    viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                                    <g id="_x23_000000ff">
                                        <path class="st0" d="M199.4,0h6.2c44,0.6,87.5,16.2,121.9,43.4c30.9,24.2,54.6,57.6,67.1,94.9c19.6,56.5,11.6,121.6-20.6,172
                                            c-4,7-9.2,13.3-14,19.8c47.6,47.6,95.3,95.3,142.9,142.9c5,4.4,8.9,10.5,8.9,17.4v2.1c-0.9,10.2-9.4,18.7-19.6,19.6h-2.9
                                            c-5.5-0.4-10.7-3-14.5-6.9c-48.3-48.3-96.6-96.6-145-144.9c-18.9,15-40.2,27-63.1,34.6c-41.8,14-88.4,14.3-130-0.5
                                            C87.3,377.3,45,340.2,21.7,293.3C7.8,266.3,0.5,236,0,205.6v-6.3C0.7,145.3,24.5,92,64.1,55.2C100.2,20.9,149.5,0.7,199.4,0
                                            M184.6,43.8c-18.4,2.3-36.5,7.3-53,15.8c-40.3,19.9-71.5,57.6-83.1,101c-11.9,42.5-4.9,89.8,18.8,127
                                            c21.9,35.2,58.1,61.3,98.6,70.6c25.9,6.2,53.5,5.7,79.2-1.5c44.8-12,83.4-44.9,102.7-87.1c19.7-41.9,19.7-92.5-0.1-134.3
                                            C328.4,93.3,289.8,60.5,245,48.5C225.4,43,204.8,41.6,184.6,43.8z"/>
                                    </g>
                                </svg>
                            </button>
                            <ul class="dropdown-menu">
                                <div class=""><h4>Search</h4></div>
                                <div class="p-3">
                                    <form action="" method="post" @submit.prevent="submit">
                                        <div class="mb-3">
                                            <div class="d-flex justify-content-start">
                                                <div class="me-4">
                                                    <input class="searchTarget" id="searchBuy" type="radio" required value="buy" v-model="form.searchTarget" checked><label for="searchBuy">Buy</label>
                                                </div>
                                                <div class="me-4">
                                                    <input class="searchTarget" id="searchSell" type="radio" required value="rent" v-model="form.searchTarget"><label for="searchSell">Rent</label>
                                                </div>
                                                <div class="me-4">
                                                    <input class="searchTarget" id="searchInt" type="radio" required value="international-properties" v-model="form.searchTarget"><label for="searchInt">International</label>
                                                </div>
                                            </div>
                                            <div class="input-group mt-3 border">
                                                <div class="input-group-text rounded-0 bg-transparent border-0">
                                                    <button type="button" class="btn bg-transparent p-0 m-0 border-0 disabled">
                                                        <svg xmlns="http://www.w3.org/2000/svg" style="width: 16px" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                                            <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                                        </svg>
                                                    </button>
                                                </div>
                                                <input required minlength="2" maxlength="255" type="text" v-model="form.search" class="bg-transparent rounded-0 form-control text-white shadow-none border-white border-0" placeholder="Search Properties" aria-describedby="helpId">
                                                <div class="input-group-text rounded-0 bg-transparent border-0">
                                                    <button type="submit" class="btn bg-transparent p-0 m-0 border-0">
                                                        <svg class="infinite-search" xmlns="http://www.w3.org/2000/svg" style="width: 16px" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                                            <path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </ul>
                        </div>
                        <JetButton :type="'button'" class="px-lg-3 px-xl-4" data-bs-toggle="modal" data-bs-target="#enquiryModal">
                            <span>Enquire</span>
                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 143 158"
                                    style="enable-background:new 0 0 143 158;" xml:space="preserve">
                                    <g id="_x23_ffffffff">
                                    </g>
                                    <g id="_x23_1e1e1eff">
                                        <path class="st0"
                                            d="M13.5,10c39.9,23.1,79.9,46.1,119.8,69.2c-39.9,23-79.8,46.1-119.8,69.1C13.5,102.2,13.5,56.1,13.5,10z" />
                                    </g>
                                </svg>
                        </JetButton>
                    </div>
                </div>
            </div>
        </nav>
    </header>

    <div class="side-nav">
            <div class="side-nav-header">
                <figure class="mb-0">
                    <img :src="asset('/images/common/logo-b.png')" alt="">
                </figure>
                <span class="btn hide-nav">
                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                        <path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M368 368L144 144m224 0L144 368"></path>
                    </svg>
                </span>
            </div>
            <div class="side-nav-body">
                <ul class="list-unstyled">
                    <li class="d-flex" :class="route().current() == 'index' ? 'active' : ''">
                        <div class="nav-link dot-container px-2"><div class="dot"></div></div>
                        <JetNavLink class="nav-link w-100" :href="route('index')">Home</JetNavLink>
                    </li>
                    <!-- <li class="d-flex" :class="(route().current() == 'development-consultancy') ? 'active' : ''">
                        <div class="nav-link dot-container px-2"><div class="dot"></div></div>
                        <div class="accordion w-100" id="accordionDevelopment">
                          <div class="accordion-item border-0">
                            <a class="nav-link nav-bar-accordion" data-bs-toggle="collapse" data-bs-target="#navDevelopmentAcc" aria-expanded="false"
                                aria-controls="navDevelopmentAcc" href="javascript:void(0);">Development Consultancy</a>
                            <div id="navDevelopmentAcc" class="accordion-collapse collapse" aria-labelledby="Development" data-bs-parent="#accordionDevelopment">
                              <div class="accordion-body">
                                <JetNavLink class="nav-link border-0" :href="route('development-consultancy') + '#end'">End To End Service</JetNavLink>
                                <JetNavLink class="nav-link border-0" :href="route('development-consultancy') + '#value-addition'">Value Addition</JetNavLink>
                                <JetNavLink class="nav-link border-0" :href="route('development-consultancy') + '#associate'">Our Associates</JetNavLink>
                              </div>
                            </div>
                          </div>
                        </div>
                    </li> -->
                    <li class="d-flex" :class="route().current() == 'development-consultancy' ? 'active' : ''">
                        <div class="nav-link dot-container px-2"><div class="dot"></div></div>
                        <JetNavLink class="nav-link w-100" :href="route('development-consultancy')">Development Consultancy</JetNavLink>
                    </li>
                    <li class="d-flex" :class="route().current() == 'bulk-investments' ? 'active' : ''">
                        <div class="nav-link dot-container px-2"><div class="dot"></div></div>
                        <JetNavLink class="nav-link w-100" :href="route('bulk-investments')">Bulk Investments</JetNavLink>
                    </li>
                    <li class="d-flex" :class="route().current() == 'buy' ? 'active' : ''">
                        <div class="nav-link dot-container px-2"><div class="dot"></div></div>
                        <JetNavLink class="nav-link w-100" :href="route('buy')">Buy</JetNavLink>
                    </li>
                    <li class="d-flex" :class="route().current() == 'sell' ? 'active' : ''">
                        <div class="nav-link dot-container px-2"><div class="dot"></div></div>
                        <JetNavLink class="nav-link w-100" :href="route('sell')">Sell</JetNavLink>
                    </li>
                    <li class="d-flex" :class="route().current() == 'rent' ? 'active' : ''">
                        <div class="nav-link dot-container px-2"><div class="dot"></div></div>
                        <JetNavLink class="nav-link w-100" :href="route('rent')">Rent</JetNavLink>
                    </li>
                    <li class="d-flex" :class="route().current() == 'about' ? 'active' : ''">
                        <div class="nav-link dot-container px-2"><div class="dot"></div></div>
                        <JetNavLink class="nav-link w-100" :href="route('about')">About Us</JetNavLink>
                    </li>

                    <!-- <li class="d-flex" :class="(route().current() == 'buy' || route().current() == 'sell' || route().current() == 'rent' || route().current() == 'international-properties') ? 'active' : ''">
                        <div class="nav-link dot-container px-2"><div class="dot"></div></div>
                        <div class="accordion w-100" id="accordionBuy">
                          <div class="accordion-item border-0">
                            <a class="nav-link nav-bar-accordion" data-bs-toggle="collapse" data-bs-target="#navBuyAcc" aria-expanded="false"
                                aria-controls="navBuyAcc" href="javascript:void(0);">Individual Units</a>
                            <div id="navBuyAcc" class="accordion-collapse collapse" aria-labelledby="Buy" data-bs-parent="#accordionBuy">
                              <div class="accordion-body">
                                <JetNavLink class="nav-link border-0" :class="(route().current() == 'buy') ? 'active' : ''" :href="route('buy')">Buy</JetNavLink>
                                <JetNavLink class="nav-link border-0" :class="(route().current() == 'sell') ? 'active' : ''" :href="route('sell')">Sell</JetNavLink>
                                <JetNavLink class="nav-link border-0" :class="(route().current() == 'rent') ? 'active' : ''" :href="route('rent')">Rent</JetNavLink>
                                <JetNavLink class="nav-link border-0" :class="(route().current() == 'international-properties') ? 'active' : ''" :href="route('international-properties')">International Properties</JetNavLink>
                              </div>
                            </div>
                          </div>
                        </div>
                    </li> -->

                    <li class="d-flex" :class="(route().current() == 'buyers-handbook' || route().current() == 'sellers-handbook' || route().current() == 'tenants-handbook' || route().current() == 'landlords-handbook' || route().current() == 'neighbourhood-diaries') ? 'active' : ''">
                        <div class="nav-link dot-container px-2"><div class="dot"></div></div>
                        <div class="accordion w-100" id="accordionSell">
                          <div class="accordion-item border-0">
                            <a class="nav-link nav-bar-accordion" data-bs-toggle="collapse" data-bs-target="#navSellAcc" aria-expanded="false"
                                aria-controls="navSellAcc" href="javascript:void(0);">Insights</a>
                            <div id="navSellAcc" class="accordion-collapse collapse" aria-labelledby="Sell" data-bs-parent="#accordionSell">
                              <div class="accordion-body">
                                <JetNavLink class="nav-link border-0" :class="(route().current() == 'buyers-handbook') ? 'active' : ''" :href="route('buyers-handbook')">Buyer's Handbook</JetNavLink>
                                <JetNavLink class="nav-link border-0" :class="(route().current() == 'sellers-handbook') ? 'active' : ''" :href="route('sellers-handbook')">Seller's Handbook</JetNavLink>
                                <JetNavLink class="nav-link border-0" :class="(route().current() == 'tenants-handbook') ? 'active' : ''" :href="route('tenants-handbook')">Tenant's Handbook</JetNavLink>
                                <JetNavLink class="nav-link border-0" :class="(route().current() == 'landlords-handbook') ? 'active' : ''" :href="route('landlords-handbook')">Landlord's Handbook</JetNavLink>
                                <JetNavLink class="nav-link border-0" :class="(route().current() == 'neighbourhood-diaries') ? 'active' : ''" :href="route('neighbourhood-diaries')">Neighbourhood Diaries</JetNavLink>
                              </div>
                            </div>
                          </div>
                        </div>
                    </li>
                    <li class="d-flex" :class="(route().current() == 'contact' || route().current() == 'careers' || route().current() == 'partners') ? 'active' : ''">
                        <div class="nav-link dot-container px-2"><div class="dot"></div></div>
                        <div class="accordion w-100" id="accordionCompany">
                          <div class="accordion-item border-0">
                            <a class="nav-link nav-bar-accordion" data-bs-toggle="collapse" data-bs-target="#navCompanyAcc" aria-expanded="false"
                                aria-controls="navCompanyAcc" href="javascript:void(0);">Contact</a>
                            <div id="navCompanyAcc" class="accordion-collapse collapse" aria-labelledby="Company" data-bs-parent="#accordionCompany">
                              <div class="accordion-body">
                                <JetNavLink class="nav-link border-0" :class="(route().current() == 'contact') ? 'active' : ''" :href="route('contact')">Contact Us</JetNavLink>
                                <JetNavLink class="nav-link border-0" :class="(route().current() == 'careers') ? 'active' : ''" :href="route('careers')">Careers</JetNavLink>
                                <!-- <JetNavLink class="nav-link border-0" :class="(route().current() == 'partners') ? 'active' : ''" :href="route('partners')">Partners</JetNavLink> -->
                              </div>
                            </div>
                          </div>
                        </div>
                    </li>
                </ul>
                <form class="form-right-search">
                    <!-- <JetButton :type="'button'" class="search-btn">
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                            <g id="_x23_000000ff">
                                <path class="st0" d="M199.4,0h6.2c44,0.6,87.5,16.2,121.9,43.4c30.9,24.2,54.6,57.6,67.1,94.9c19.6,56.5,11.6,121.6-20.6,172
                                    c-4,7-9.2,13.3-14,19.8c47.6,47.6,95.3,95.3,142.9,142.9c5,4.4,8.9,10.5,8.9,17.4v2.1c-0.9,10.2-9.4,18.7-19.6,19.6h-2.9
                                    c-5.5-0.4-10.7-3-14.5-6.9c-48.3-48.3-96.6-96.6-145-144.9c-18.9,15-40.2,27-63.1,34.6c-41.8,14-88.4,14.3-130-0.5
                                    C87.3,377.3,45,340.2,21.7,293.3C7.8,266.3,0.5,236,0,205.6v-6.3C0.7,145.3,24.5,92,64.1,55.2C100.2,20.9,149.5,0.7,199.4,0
                                    M184.6,43.8c-18.4,2.3-36.5,7.3-53,15.8c-40.3,19.9-71.5,57.6-83.1,101c-11.9,42.5-4.9,89.8,18.8,127
                                    c21.9,35.2,58.1,61.3,98.6,70.6c25.9,6.2,53.5,5.7,79.2-1.5c44.8-12,83.4-44.9,102.7-87.1c19.7-41.9,19.7-92.5-0.1-134.3
                                    C328.4,93.3,289.8,60.5,245,48.5C225.4,43,204.8,41.6,184.6,43.8z"/>
                            </g>
                        </svg>
                    </JetButton> -->
                    <JetButton :type="'button'" class="px-4 py-2" data-bs-toggle="modal" data-bs-target="#enquiryModal">
                        <span>Enquire</span>
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 143 158"
                                style="enable-background:new 0 0 143 158;" xml:space="preserve">
                                <g id="_x23_ffffffff">
                                </g>
                                <g id="_x23_1e1e1eff">
                                    <path class="st0"
                                        d="M13.5,10c39.9,23.1,79.9,46.1,119.8,69.2c-39.9,23-79.8,46.1-119.8,69.1C13.5,102.2,13.5,56.1,13.5,10z" />
                                </g>
                            </svg>
                    </JetButton>
                </form>
            </div>
        </div>
</template>
